<template>
  <div class="budget-usage-bar" :class="{ 'budget-usage-bar--compact': compact }">
    <div class="budget-usage-bar__track">
      <div
        class="budget-usage-bar__fill"
        :class="`budget-usage-bar__fill--${state}`"
        :style="{ width: `${percent}%` }"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { budgetUsagePercent, budgetUsageState } from '@/pages/recognition/utils/budgets';

const props = defineProps({
  budget: {
    type: Object,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
});

const percent = computed(() => budgetUsagePercent(props.budget));
const state = computed(() => budgetUsageState(props.budget));
</script>

<style scoped lang="scss">
.budget-usage-bar {
  display: flex;
  align-items: center;
  width: 100%;

  &--compact {
    max-width: 6rem;
  }

  &__track {
    flex: 1 1 auto;
    height: 0.25rem;
    border-radius: 0.125rem;
    background-color: var(--palette-color-default-lighten-90);
    overflow: hidden;
  }

  &__fill {
    height: 100%;
    background-color: var(--palette-color-brand-primary);
    transition: width 0.3s ease;

    &--low {
      background-color: var(--palette-color-warning);
    }

    &--exhausted {
      background-color: var(--palette-color-danger);
    }
  }
}
</style>
